module.exports = __webpack_public_path__ + "img/hu.d0289dc0.png";